/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';
import * as angular from 'angular';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';
import { PlanAccessCheck } from 'src/app/services/PlanAccessCheck';

angular
	.module('ticketspaceApp')
	// Removed $rootScope
	.factory('firebaseVariances', [
		'$q',
		'$log',
		'$firebaseUtils',
		'$firebaseArray',
		'fbConnection',
		'popup',
		'planAccessCheck',
		function (
			$q,
			$log,
			$firebaseUtils,
			$firebaseArray,
			fbConnection,
			popup,
			planAccessCheck: PlanAccessCheck
		) {
			const logger = LoggerServiceFactory.create('firebaseVariances');
			let theMax = 101;
			let styles = [
				'#5DA4DA',
				'#F25858',
				'#FAA43D',
				'#F27CB1',
				'#61BC67',
				'#DFCF40',
				'#B475B4',
				'#B2902E',
				'#2F7D99',
				'#4E4C4D',
				'#9BFFA3',
				'#F6F63A',
				'#6b156b',
				'#f3dcc0',
				'#d1ebff',
				'#ad0b0b',
			];

			function Variance(snap) {
				this.$id = snap.key;
				this.local = {};
				this.update(snap);
			}
			Variance.prototype = {
				update(snap) {
					//store the data on...data
					let oldData = this.data || {};

					this.data = snap.val();
					let changed = !angular.equals(this.data, oldData);
					this.local.prevData = oldData;
					return changed;
				},
				toJSON() {
					//return the parsed data from it's "data" location
					return $firebaseUtils.toJSON(this.data);
				},
				displayName() {
					return this.data.varianceKey + '. ' + this.data.varianceReason;
				},
			};

			function VarianceFactory(ref) {
				// call the super constructor
				this._usedStyles = {};
				let thing = $firebaseArray.call(this, ref);
				thing._usedStyles = this._usedStyles;
				thing.backgroundStyleList = styles;
				return thing;
			}
			VarianceFactory.prototype = {
				$$added(snap) {
					$firebaseArray.prototype.$$added.call(this, snap);
					let v = new Variance(snap);
					this.updateUsedStyles('add', snap);
					return v;
				},
				$$updated(snap) {
					let rec = this.$getRecord(snap.key);
					let changed = rec.update(snap);
					this.updateUsedStyles('change', snap, rec.local.prevData.varianceColor);

					return changed;
				},
				$$removed(snap) {
					this.updateUsedStyles('remove', snap, snap);
					return this.$getRecord(snap.key);
				},
				$add(data) {
					let self = this;
					let args = arguments;

					if (this.$list.length >= theMax - 1) {
						return $q.rejectErr('Please contact Customer Support to add this variance');
					}

					//data.varianceColor = this.nextStyle();

					if (!data || !data.varianceReason) {
						return $q.rejectErr('Reason is required.');
					}
					return this.getNextKey().then(function (key) {
						data.varianceKey = key;
						data.varianceColor = self.nextStyle(key);

						return $firebaseArray.prototype.$add.apply(self, args);
					});
				},
				$remove(idx) {
					return $firebaseArray.prototype.$remove.apply(this, arguments);
				},
				confirmRemove(idx) {
					let self = this;
					let args = arguments;
					return popup({ title: 'Are you sure you want to delete this variance reason?' }).then(function () {
						return self.$remove.apply(self, args);
					});
				},
				getNextKey() {
					let self = this;
					return new $q(function (resolve, reject) {
						self.$list.counter.$ref().transaction(
							function (currentVal) {
								return (currentVal || 0) + 1;
							},
							function (error, committed, snap) {
								if (error) {
									reject(error);
								} else if (committed) {
									resolve(snap.val());
								}
							}
						);
					});
				},
				set(idx, data) {
					//logger.log('setting', idx, data);
					let item = this.$list[idx];
					if (!item) {
						return $q.rejectErr("item doesn't exist");
					}
					if (!data || !data.varianceReason || !data.varianceColor) {
						return $q.rejectErr('name and style is required');
					}
					item.data.varianceReason = data.varianceReason;
					item.data.varianceColor = data.varianceColor;
					return this.$save(idx);
				},
				updateUsedStyles,
				nextStyle,
				cloneForEdit,
			};

			//lifted out of roles.js, could probably stand to be modernized
			function updateUsedStyles(action, snap, oldVal) {
				let self = this;
				if (snap.exists()) {
					let style = snap.child('varianceColor').val();
					if (action === 'add' && style) {
						add(style);
					} else if (action === 'remove' && style) {
						remove(style);
					} else if (action === 'change') {
						let oldStyle = oldVal;
						if (oldStyle !== style) {
							add(style);
							remove(oldStyle);
						}
					}
				}

				//logger.log(action, this._usedStyles, style, oldVal);

				function add(style) {
					if (!style) {
						return;
					}
					if (!self._usedStyles[style]) {
						self._usedStyles[style] = 1;
					} else {
						self._usedStyles[style]++;
					}
				}
				function remove(style) {
					if (!style) {
						return;
					}
					if (self._usedStyles[style] === 1) {
						delete self._usedStyles[style];
					} else {
						self._usedStyles[style]--;
					}
				}
			}
			function nextStyle(key) {
				return styles[key % styles.length];
				// var options = styles;
				// var self = this;
				// var match;
				//
				// options.every(function(style){
				// 	match = style;
				// 	return self.$list.some(function(v){
				// 		if(v.data.varianceColor === style){ return true; }
				// 		return false;
				// 	});
				// });
				// return match;
			}

			function cloneForEdit(index, collection) {
				if (index === -1) {
					return { varianceColor: collection.nextStyle() };
				}
				if (index !== -1 && collection[index] !== undefined) {
					let obj = angular.extend({}, collection[index].data);
					return obj;
				}
				return {};
			}

			let eFactory = $firebaseArray.$extend(VarianceFactory);

			return function (refUrl) {
				let sync = new eFactory(refUrl);
				let counter = fbConnection.fbObject(refUrl.ref.parent.child('varianceCount'));
				sync.counter = counter;

				//init the counter
				if (planAccessCheck.isAdminSync) {
					$q.all([sync.$loaded(), counter.$loaded()]).then(function () {
						if (counter.$value === null && sync.length) {
							counter.$ref().transaction(function (data) {
								return sync.reduce(function (oldThing, newThing) {
									return newThing.data.varianceKey > oldThing.data.varianceKey ? newThing : oldThing;
								}).data.varianceKey;
							});
						}
					});
				}

				return sync;
			};
		},
	]);
